import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { FlatList, StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { useRecentlyViewedHotels } from "../../../../providers/api/RecentlyViewedHotelsContext";
import { appendTestId } from "../../../../utils";
import {
  PreviousHotelSearchData,
  SelectedPreviousHotelSearchData,
} from "../HotelSearchForm";
import PreviousSearchItem from "./PreviousSearchItem";
import RecentlyViewedHotel from "./RecentlyViewedHotel";

type Props = {
  onCloseDialog: () => void;
  previousSearchData?: PreviousHotelSearchData[];
  selectPreviousSearchData: (
    searchData: SelectedPreviousHotelSearchData
  ) => void;
  testID?: string;
};

export default function EmptySearch(props: Props) {
  const {
    onCloseDialog,
    previousSearchData,
    selectPreviousSearchData,
    testID,
  } = props;
  const { CorporateHotelSearchForm, CorporateHotelRecentlySearch } =
    useMobileContentResource();
  const hotels = useRecentlyViewedHotels();
  function handleSelectPreviousSearchData(
    previousSearchData: SelectedPreviousHotelSearchData
  ) {
    selectPreviousSearchData(previousSearchData);
    onCloseDialog();
  }
  return (
    <BMView>
      {previousSearchData && previousSearchData.length > 0 && (
        <BMView>
          <BMView style={styles.container}>
            <BMText ink="BMStyleTextInkPrimary" variant="titleSmall">
              {CorporateHotelSearchForm.continueSearch}
            </BMText>
          </BMView>
          <FlatList
            horizontal
            data={previousSearchData}
            renderItem={({ item, index }) => (
              <PreviousSearchItem
                selectPreviousSearchData={handleSelectPreviousSearchData}
                searchItem={item}
                testID={appendTestId(testID, `previous_search_item-${index}`)}
              />
            )}
            style={styles.list}
            contentContainerStyle={styles.listItem}
            showsHorizontalScrollIndicator={false}
          />
        </BMView>
      )}
      {!!hotels?.recentlySearchedHotels?.length && (
        <BMView style={styles.recentlyViewed}>
          <BMText
            style={styles.recentlyViewedTitle}
            ink="BMStyleTextInkPrimary"
            variant="titleSmall"
          >
            {CorporateHotelRecentlySearch.recentlyViewedHotelText}
          </BMText>
          <FlatList
            horizontal
            data={hotels?.recentlySearchedHotels}
            renderItem={({ item, index }) => (
              <RecentlyViewedHotel
                testID={appendTestId(testID, `recently_viewed_hotel-${index}`)}
                onCloseDialog={onCloseDialog}
                hotel={item}
              />
            )}
            style={styles.list}
            contentContainerStyle={styles.listItem}
            showsHorizontalScrollIndicator={false}
          />
        </BMView>
      )}
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: BMPrimitives.BMSize.lg,
    paddingHorizontal: BMPrimitives.BMSize.lg,
  },
  list: {
    marginTop: BMPrimitives.BMSize.md,
    paddingHorizontal: BMPrimitives.BMSize.md,
  },
  listItem: {
    gap: BMPrimitives.BMSize.md,
  },
  recentlyViewed: {
    marginTop: BMPrimitives.BMSize.xl,
  },
  recentlyViewedTitle: {
    paddingLeft: BMPrimitives.BMSize.lg,
  },
});
